<template>
  <div>
    <article class="partners-wrapper">
      <div class="container">
        <p class="title-text">Global Partners</p>
        <div class="slide-wrapper">
          <VueSlickCarousel v-bind="settings" v-if="slideList.length > 0">
            <div class="slide" v-for="(item, i) in slideList" :key="i">
              <div class="con">
                <img :src="item.profileImg" alt="img" />
                <div class="text-wrapper">
                  <p>{{ item.date }}</p>
                  <p>{{ item.title }}</p>
                  <p>{{ item.sub }}</p>
                  <p class="more" @click="showImgView(item)">more</p>
                </div>
              </div>
            </div>
          </VueSlickCarousel>
        </div>
      </div>
    </article>

    <!-- 이미지 뷰 모달 -->
    <ImageView
      v-if="isimgViewVisible"
      @closeImgView="hideImgView"
      :imgP="imageData.imgP"
      :imgM="imageData.imgM"
    ></ImageView>
  </div>
</template>
<script>
import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";
import ImageView from "@/page/NewGlobal/ImageView.vue";

export default {
  components: { VueSlickCarousel, ImageView },
  data() {
    return {
      settings: {
        dots: true,
        arrows: false,
        infinite: true,
        autoplay: true,
        speed: 1000,
        autoplaySpeed: 9000,
        cssEase: "linear",
        pauseOnHover: true,
      },
      slideList: [],
      /* slideList_old: [
        {
          date: "23년 7~8월 호",
          profileImg: require("@/assets/img/newGlobal/main/partners/partner01.jpg"),
          title:
            "입사부터 퇴사까지, 전체 라이프사이클에 걸쳐 주요한 순간들에 육성을 지원",
          sub: `동화기업의 직원교육방향은, 첫째로, 동화그룹은 직원의 입사부터 퇴사까지, 전(全) 라이프사이클에 걸쳐 주요한 순간들에 육성을 지원하고 있으며, 특히 리더의 파이프라인 강화 및 팀장 리더십 강화에 초점을 두고 교육을 진행하고 있습니다. 이외 임직원은 온보딩 및 DDDM(Data Driven Decision Making) 역량, 글로벌 역량 등 미래 역량 확보에 중점을 두고 있습니다. 직원경험에서 중요한 개인의...`,
          imgM: "https://kr.object.ncloudstorage.com/newglobal/main/partners/global_partner_mobile_01.jpg",
          imgP: "https://kr.object.ncloudstorage.com/newglobal/main/partners/global_partner_pc_01.jpg",
        },
        {
          date: "23년 5~6월 호",
          profileImg: require("@/assets/img/newGlobal/main/partners/partner02.png"),
          title:
            "누구나 글로벌 사업에 참여할 수 있도록 전직원 대상 상시 글로벌 교육 운영",
          sub: `한국가스공사의 교육이념은 '투철한 사명의식을 바탕으로 에너지산업의 미래에 도전하는 창의적인 KOGAS인을 육성' 하는 것입니다. 그리고 그러한 이념을 실천하기 위해 기반역량, 리더십역량, 직무역량, 글로벌 역량으로 나누어진 역량기반 교육체계를 구성하여 교육과정을 운영하고 있습니다...`,
          imgM: "https://kr.object.ncloudstorage.com/newglobal/main/partners/global_partner_mobile_02.jpg",
          imgP: "https://kr.object.ncloudstorage.com/newglobal/main/partners/global_partner_pc_02.jpg",
        },
        {
          profileImg: require("@/assets/img/newGlobal/main/partners/partner03.png"),
          date: "23년 5~6월 호",
          title: "구성원들의 성장을 맞춤형으로 지원하여 함께 성장하는 조직",
          sub: `HK inno.N에는 'inno.N Spirit'(우리의 마음가짐)이 있습니다. 이는 HK inno.N 임직원이라면 어떻게 일해야 하는가 방향을 제시하는 것입니다. 그 중 '함께 성장합니다' 는 조직 내에서 구성원들이 잠재 역량을 발휘할 수 있도록, 다양한 프로그램을 통해 구성원들의 성장을 지원하는 것인데요, 이를 위해 회사의 성장을 이끌어갈 '반듯한 인재' 육성을 목표로 구성원들의 성장을 지원하고 있습니다. 공통 교육, 입문 교육, 리더십 교육, 직무 교육, 글로벌 역량 교육, 개인 맞춤형 교육을 단계적으로 개발해나갈 수 있도록...`,
          imgM: "https://kr.object.ncloudstorage.com/newglobal/main/partners/global_partner_mobile_03.jpg",
          imgP: "https://kr.object.ncloudstorage.com/newglobal/main/partners/global_partner_pc_03.jpg",
        },
        {
          profileImg: require("@/assets/img/newGlobal/main/partners/partner04.png"),
          date: "23년 3~4월 호",
          title: "현장사례 중심과 지식 공유환경 제공에 초점",
          sub: `쿠팡풀필먼트서비스(이하 CFS)는 두 가지 지구언교육 방향을 가지고 있습니다. 첫 번째, 현장의 케이스를 반영한 교육 프로그램 제공입니다. CFS의 직원 대부분은 FC 현장에서 근무 중이므로 현장에서 바로 적용이 가능한 교육을 제공하는 것을 가장 중요하게 생각하고 있습니다. Fc 현장에서 직원들이 바로 이행할 수 있도록 교육 전 충분한 설문, 인터뷰 등 현장에서 발생되는 실제 사례 등을 교육 콘텐츠 내에 최대한 반영하여 현장에서 바로 유사한 상황에 적용이...`,
          imgM: "https://kr.object.ncloudstorage.com/newglobal/main/partners/global_partner_mobile_04.jpg",
          imgP: "https://kr.object.ncloudstorage.com/newglobal/main/partners/global_partner_pc_04.jpg",
        },
        {
          profileImg: require("@/assets/img/newGlobal/main/partners/partner05.png"),
          date: "23년 1~2월 호",
          title: "육성 니즈를 파악하여 사업의 목표 및 성과달성 지원",
          sub: `(주)두산 사업부문은 두산의 철학인 두산 Credo를 근가으로 구성원을 육성하고 있으며 교육 체계상 리더십과 직무영역으로 크게 나누어 육성 방향을 수립하고 있습니다. 두산의 철학을 이해하고 리더십을 배양하는 리더십 과정은 역할에 기반하여 정기적으로 실시하고 있으며, 직무교육은 성장단계에 따라 필요한 시점에 교육을 실시하고 있습니다. 전사적으로 필요한 교육은 제도화하여 (주)두산 사업부문에서 공통으로 실시하고...`,
          imgM: "https://kr.object.ncloudstorage.com/newglobal/main/partners/global_partner_mobile_05.jpg",
          imgP: "https://kr.object.ncloudstorage.com/newglobal/main/partners/global_partner_pc_05.jpg",
        },
      ], */

      isimgViewVisible: false,
    };
  },
  mounted() {
    this.getPartners();
  },
  methods: {
    showImgView(item) {
      this.isimgViewVisible = true;
      this.imageData = {
        imgP: item.imgP,
        imgM: item.imgM,
      };
    },

    hideImgView() {
      this.isimgViewVisible = false;
    },

    getPartners() {
      const params = {
        limit: 5,
      };
      axios
      .get("/rest/external/getPartners", {params: params})
      .then((res) => {
        if (res.data.err == 0) {
          this.slideList = res.data.list;
        } else {
          console.error("res.data.err : ", res.data.err);
        }
      })
      .catch((err) => {
        alert("통신이 원활하지 않습니다.");
        console.error("err : ", err);
      });
    }
  },
};
</script>
<style lang="scss" scoped>
.partners-wrapper {
  position: relative;
  padding: 40px 0px;
  color: #232323;
  background-color: #f7f7f7;

  .title-text {
    font-size: 33px;
    font-weight: 700;
    margin-bottom: 25px;
  }

  .slide-wrapper {
    .con {
      img {
        width: 100%;
        margin-bottom: 50px;
      }

      .text-wrapper {
        p:nth-of-type(1) {
          font-size: 20px;
          font-weight: 700;
          margin-bottom: 20px;
        }

        p:nth-of-type(2) {
          font-size: 22px;
          font-weight: 700;
          margin-bottom: 10px;
        }

        p:nth-of-type(3) {
          margin-bottom: 40px;
        }

        .more {
          color: #232323;
          cursor: pointer;
        }
      }
    }

    .slick-slider::v-deep {
      .slick-slide {
        margin-bottom: 10px;

        .slide {
          display: block !important;
        }
      }

      .slick-dots {
        position: relative;
        text-align: center;
        bottom: -30px;

        li {
          width: 24px;
          height: 24px;

          button {
            width: 24px;
            height: 24px;

            &::before {
              font-size: 24px;
            }
          }
        }
      }
    }
  }
}

@media screen and (min-width: 1350px) {
  .partners-wrapper {
    padding: 80px 0px;

    .container {
      position: relative;
    }

    .title-text {
      font-size: 50px;
    }

    .slide-wrapper {
      .con {
        display: flex;
        align-items: center;
        gap: 100px;

        img {
          width: 480px;
          margin-bottom: 0;
        }
      }
    }
  }
}
</style>
